import { colord } from 'colord';
import { useState } from 'react';
import styled from 'styled-components';
import { extractNumber } from '../../../../functions/utils/extractNumber';
import { DropdownInput } from '../DropdownInput';
import { NumberInput } from '../NumberInput';
import { TextInput } from '../TextInput';

export const ColorPickerModalColorInputs = ({
  value,
  onChange,
}: {
  value?: string | null;
  onChange: (newValue: string | undefined) => void;
}) => {
  const [colorMode, setColorMode] = useState<string>('rgba');
  const color = colord(value || 'transparent');
  const rgba = color.toRgb();
  const hex = color.toHex();
  const hsla = color.toHsl();

  return (
    <>
      <DropdownInput
        value={colorMode}
        onChange={(newValue) => setColorMode(String(newValue))}
        options={[
          { value: 'hex', label: 'HEX' },
          { value: 'rgba', label: 'RGBA' },
          { value: 'hsla', label: 'HSLA' },
        ]}
        canBeCleared={false}
        isSearchable={false}
      />
      <InputsContainer>
        {colorMode === 'hex' && (
          <Row>
            <TextInput value={hex} onBlur={onChange} />
          </Row>
        )}
        {colorMode === 'rgba' && (
          <Row>
            <NumberInput
              value={String(rgba.r)}
              onChange={(newRedValue) => {
                const extractedNumber = extractNumber(newRedValue);
                if (extractedNumber === null) return;

                rgba.r = extractedNumber;
                onChange(colord(rgba).toHex());
              }}
              inputStyle={{ textAlign: 'center' }}
              precision={0}
              minValue={0}
              maxValue={255}
            />
            <NumberInput
              value={String(rgba.g)}
              onChange={(newGreenValue) => {
                const extractedNumber = extractNumber(newGreenValue);
                if (extractedNumber === null) return;

                rgba.g = extractedNumber;
                onChange(colord(rgba).toHex());
              }}
              inputStyle={{ textAlign: 'center' }}
              precision={0}
              minValue={0}
              maxValue={255}
            />
            <NumberInput
              value={String(rgba.b)}
              onChange={(newBlueValue) => {
                const extractedNumber = extractNumber(newBlueValue);
                if (extractedNumber === null) return;

                rgba.b = extractedNumber;
                onChange(colord(rgba).toHex());
              }}
              inputStyle={{ textAlign: 'center' }}
              precision={0}
              minValue={0}
              maxValue={255}
            />
            <NumberInput
              value={String(rgba.a)}
              onChange={(newAlphaValue) => {
                const extractedNumber = extractNumber(newAlphaValue);
                if (extractedNumber === null) return;

                rgba.a = extractedNumber;
                onChange(colord(rgba).toHex());
              }}
              inputStyle={{ textAlign: 'center' }}
              precision={2}
              minValue={0}
              maxValue={1}
              draggingStep={0.1}
              draggingSensitive={0.1}
            />
          </Row>
        )}
        {colorMode === 'hsla' && (
          <Row>
            <NumberInput
              value={String(hsla.h)}
              onChange={(newHueValue) => {
                const extractedNumber = extractNumber(newHueValue);
                if (extractedNumber === null) return;

                hsla.h = extractedNumber;
                onChange(colord(hsla).toHex());
              }}
              inputStyle={{ textAlign: 'center' }}
              precision={0}
              minValue={0}
              maxValue={360}
            />
            <NumberInput
              value={String(hsla.s)}
              onChange={(newSaturationValue) => {
                const extractedNumber = extractNumber(newSaturationValue);
                if (extractedNumber === null) return;

                hsla.s = extractedNumber;
                onChange(colord(hsla).toHex());
              }}
              inputStyle={{ textAlign: 'center' }}
              precision={0}
              minValue={0}
              maxValue={100}
            />
            <NumberInput
              value={String(hsla.l)}
              onChange={(newLightnessValue) => {
                const extractedNumber = extractNumber(newLightnessValue);
                if (extractedNumber === null) return;

                hsla.l = extractedNumber;
                onChange(colord(hsla).toHex());
              }}
              inputStyle={{ textAlign: 'center' }}
              precision={0}
              minValue={0}
              maxValue={100}
            />
            <NumberInput
              value={String(hsla.a)}
              onChange={(newAlphaValue) => {
                const extractedNumber = extractNumber(newAlphaValue);
                if (extractedNumber === null) return;

                hsla.a = extractedNumber;
                onChange(colord(hsla).toHex());
              }}
              inputStyle={{ textAlign: 'center' }}
              precision={2}
              minValue={0}
              maxValue={1}
              draggingStep={0.1}
              draggingSensitive={0.1}
            />
          </Row>
        )}
      </InputsContainer>
    </>
  );
};

const InputsContainer = styled.div`
  padding: 5px;
`;

const Row = styled.div`
  width: 100%;
  display: flex;

  gap: 5px;
`;
